import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
//import Swoosh from './swoosh';
//import VideoLogo from './VideoLogo';
//import TwilioLogo from './TwilioLogo';
import MyEmergencyDrLogo from './MyEmergencyDrLogo';
//import { useAppState } from '../../state';
//import UserMenu from './UserMenu/UserMenu';
//import { useLocation } from 'react-router-dom';
import logo from './MED-logo-rgb.png';

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    //display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f1f1f1',
    height: '100%',
  },
  container: {
    position: 'relative',
    flex: '1',
    margin: '10px',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100% - 20px)',
    },
  },
  innerContainer: {
    display: 'flex',
    width: '888px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px 0px rgba(40, 42, 43, 0.3)',
    overflow: 'hidden',
    position: 'relative',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      height: 'calc(100% - 20px)',
      width: 'calc(100% - 40px)',
      margin: 'auto',
      maxWidth: '400px',
    },
  },
  swooshContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    //backgroundImage: Swoosh,
    backgroundColor: '#FFFFFF',
    backgroundSize: 'cover',
    width: '296px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100px',
      backgroundPositionY: '140px',
    },
  },
  logoContainer: {
    position: 'absolute',
    width: '210px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      width: '90%',
      textAlign: 'initial',
      '& svg': {
        height: '64px',
      },
    },
  },
  logo: {
    width: '210px',
  },
  twilioLogo: {
    position: 'absolute',
    top: 0,
    left: 0,
    margin: '20px',
  },
  myemergencydrLogo: {
    position: 'absolute',
    top: 0,
    left: 0,
    margin: '20px',
  },
  content: {
    background: 'white',
    width: '100%',
    padding: '4em',
    flex: 1,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '2em',
      height: '100%',
    },
  },
  title: {
    color: 'white',
    margin: '1em 0 0',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      fontSize: '1.1rem',
    },
  },
}));

interface IntroContainerProps {
  children: React.ReactNode;
}

const IntroContainer = (props: IntroContainerProps) => {
  const classes = useStyles();
  //const { user } = useAppState();
  //const location = useLocation();

  return (
    <div className={classes.background}>
      <MyEmergencyDrLogo className={classes.myemergencydrLogo} />
      {/*user && location.pathname !== '/login' && <UserMenu />*/}
      <div className={classes.container}>
        <div className={classes.innerContainer}>
          <div className={classes.swooshContainer}>
            <div className={classes.logoContainer}>
              <img src={logo} alt="MyEmergencyDr Logo" className={classes.logo} />
            </div>
          </div>
          <div className={classes.content}>{props.children}</div>
        </div>
      </div>
    </div>
  );
};

export default IntroContainer;
